/**
 * Narxni formatlash: `740 250 000 so'm`.
 * Ajratgich sifatida oddiy bo'shliq emas, **uzilmaydigan tor bo'shliq** (U+202F)
 * ishlatiladi — raqam qator oxirida bo'linib ketmasin.
 */
const NBSP_THIN = ' ';
const SUFFIX = {
    uz: "so'm",
    oz: 'сўм',
    ru: 'сум',
    en: 'UZS',
};
export function formatPrice(value, locale, opts = {}) {
    if (value === null || value === undefined)
        return null;
    const grouped = groupDigits(Math.round(value));
    if (opts.withSuffix === false)
        return grouped;
    return locale === 'en'
        ? `${SUFFIX.en}${NBSP_THIN}${grouped}`
        : `${grouped}${NBSP_THIN}${SUFFIX[locale]}`;
}
export function groupDigits(value) {
    const sign = value < 0 ? '-' : '';
    const digits = Math.abs(value).toString();
    return sign + digits.replace(/\B(?=(\d{3})+(?!\d))/g, NBSP_THIN);
}
/**
 * Komplektatsiyalar ichidan narx oralig'ini hisoblaydi.
 *
 * MUHIM: `price: null` bo'lgan («Narxni so'rang») pozitsiyalar hisobga **olinmaydi**,
 * aks holda katalogda «0 so'm dan» chiqib qoladi (ISH-REJA B4 DoD).
 */
export function priceRange(variants) {
    const prices = variants
        .filter((v) => v.isVisible !== false)
        .map((v) => v.price)
        .filter((p) => typeof p === 'number');
    if (prices.length === 0)
        return { min: null, max: null };
    return { min: Math.min(...prices), max: Math.max(...prices) };
}
/** Ariza ro'yxatidagi umumiy summa. Narxsiz pozitsiyalar qo'shilmaydi. */
export function sumItems(items) {
    let total = 0;
    let hasUnpriced = false;
    for (const it of items) {
        if (typeof it.price === 'number')
            total += it.price * it.quantity;
        else
            hasUnpriced = true;
    }
    return { total, hasUnpriced };
}
//# sourceMappingURL=price.js.map